import { environment } from '../../environments/environment';

const BASE_URL = environment.api.baseUrl;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${BASE_URL}/login`,
    LOGOUT: `${BASE_URL}/logout`,
    ME: `${BASE_URL}/me`,
    VALIDATE_TOKEN: (token: string) => `${BASE_URL}/public/link-id-check/${token}`,
    REGISTER: `${BASE_URL}/registrations`,
  },
  USERS: {
    BASE: `${BASE_URL}/users`,
    BY_ID: (id: string) => `${BASE_URL}/users/${id}`,
  },
  RFP: {
    BASE: `${BASE_URL}/rfp`,
    BY_ID: (id: string) => `${BASE_URL}/rfp/${id}`,
  },
  PROJECTS: {
    BASE: `${BASE_URL}/projects`,
    BY_ID: (id: string) => `${BASE_URL}/projects/${id}`,
  },
  CLIENTS: {
    BASE: `${BASE_URL}/clients`,
    BY_ID: (id: string) => `${BASE_URL}/clients/${id}`,
  },
  BIDDERS: {
    BASE: `${BASE_URL}/bidders`,
    BY_ID: (id: string) => `${BASE_URL}/bidders/${id}`,
  },
  INVITATIONS: {
    BASE: `${BASE_URL}/invitations`,
    BY_ID: (id: string) => `${BASE_URL}/invitations/${id}`,
  },
  ROLES: {
    BASE: `${BASE_URL}/roles`,
    BY_ID: (id: string) => `${BASE_URL}/roles/${id}`,
  },
  PROFILE: {
    BASE: `${BASE_URL}/profile`,
    PASSWORD: `${BASE_URL}/profile/password`,
  },
} as const;
